import { findVehicleByStockNumber } from "common/layout/Header/api";
import removeDoubleSlashes from "utils/removeDoubleSlashes";

export const useStockNumberSearch = (): {
    handleStockNumberSearchForm: (stockNumber: string) => Promise<void | boolean>;
} => {
    const handleStockNumberSearchForm = async (stockNumber: string): Promise<void | boolean> => {
        const url = removeDoubleSlashes(
            `${process.env.NEXT_PUBLIC_MOTORPOINT_URL}/vehiclesearch/findvehiclebystocknumber/${stockNumber}`
        );
        const response = await findVehicleByStockNumber(url);
        const {
            data: { RedirectURL, Success },
        } = response;
        if (Success) {
            window.location.href = removeDoubleSlashes(`${RedirectURL}`);

            return true;
        }

        return false;
    };

    return {
        handleStockNumberSearchForm,
    };
};
